import React from 'react';
import PropTypes from 'prop-types';
import './style.css';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  borderRadius?: string;
  duration?: string;
  count?: number;
  className?: string;
  contentClassName?: string;
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ width, height, borderRadius, duration, count, className, contentClassName }) => {
  return (
    <div className={`skeleton-loader ${className ? className : ''}`}>
      {[...Array(count || 1)].map((_, index) => (
        <div
          key={index}
          className={`skeleton-content ${contentClassName ? contentClassName : ''}`}
          style={{
            width: width || '100%',
            height: height || '1em',
            borderRadius: borderRadius || '0.25em',
            animationDuration: duration || '1.5s',
            marginBottom: index < (count || 1) - 1 ? '0.5em' : 0, // Skeleton öğeleri arasına boşluk ekleyin
          }}
        ></div>
      ))}
    </div>
  );
};

SkeletonLoader.propTypes = {
  width: PropTypes.string, // Skeleton genişliği
  height: PropTypes.string, // Skeleton yüksekliği
  borderRadius: PropTypes.string, // Skeleton kenar yarıçapı
  duration: PropTypes.string, // Animasyon süresi
  count: PropTypes.number, // Kaç adet skeleton öğe olacağı
};

export default SkeletonLoader;
